define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var template = require("web-agent-templates/tableHeaderBubbleItemView.tmpl");

    var TableHeaderBubbleItemView = {};

    LE.module(CONST.MODULES.AGENT, function (LEWebAgent, LE, Backbone, Marionette, $, _) {
        TableHeaderBubbleItemView = Marionette.ItemView.extend({

            className: 'table-header-bubble-item',
            template: template,

            events: {
                'click .url-link .bluelink': 'onUrlClicked'
            },

            onUrlClicked: function(e) {
                e.stopPropagation();
                e.preventDefault();

                var clickCB = this.model.get('urlCallback');
                if(clickCB) {
                    clickCB();
                }
            }
        });
    });

    return TableHeaderBubbleItemView;

});
